import { FC } from "react";
import { GradientButton, PhoneFrame } from "./components";
import { useLocation, useNavigate } from "react-router-dom";

import PhotoIdentificationSVG from "../../assets/IdentificationPhotoSVG.svg";

export const IdentificationAlert: FC = () => {
	const location = useLocation();

	const { accountType } = location.state;
	const navigate = useNavigate();

	return (
		<div className="w-full h-screen flex justify-center items-center gap-20 background max-2xl:gap-0">
			<PhoneFrame
				onPress={() =>
					navigate("/create-account-wallet/send-identification-photo", {
						state: { accountType },
					})
				}
			/>

			<div className="bg-[#7C7775]/80 max-w-[50%] rounded-2xl p-[4%] border-2 border-black">
				<div className="w-full flex flex-col items-center justify-center">
					<h1 className="font-bold text-white text-3xl full-hd:text-4xl 3xl-hd:text-5xl qhd:text-5xl studio-laptop:text-6xl qhd-plus:text-6xl 4k:text-8xl 5k:text-8xl leading-7 mb-[4%]">
						Identifique-se
					</h1>

					<p className="font-extralight text-white text-xl text-center mt-5 mb-8 max-2xl:mt-2 max-2xl:text-base">
						Para segurança do seu cadastro, será <br />
						necessário que você nos envie a foto <br />
						do{" "}
						<strong>{accountType === "PF" ? "seu RG" : "seu RG / CNH"}</strong>{" "}
						para prosseguir.
					</p>

					<img
						width={300}
						className="mb-8 ml-5 max-2xl:mb-0 max-2xl:w-[45%]"
						src={PhotoIdentificationSVG}
						alt=""
					/>

					<div className="flex gap-4 mt-16">
						<GradientButton
							title="Voltar"
							tailwindStyles="bg-[#171717]  w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() =>
								navigate("/create-account-wallet/send-identification-photo", {
									state: { accountType },
								})
							}
						/>
						<GradientButton
							title="Avançar"
							tailwindStyles="bg-[#AA7339]  w-[8rem] xl:w-[16rem] h-12 lg:h-16 text-white p-texte"
							onClick={() => {
								navigate("/create-account-wallet/send-document-pj", {
									state: { accountType },
								});
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
